import dataLayer from '@rover/globals/dataLayer';
import { getSourceDescription } from '@rover/rsdk/src/modules/Network/userAgent';
import { ServiceLandingEnum } from '@rover/types/src/ServiceLanding';
import emitMetric from '@rover/utilities/emitMetric';

export type CtaMetricTags = {
  component: 'hero' | 'footer';
  slug: ServiceLandingEnum;
};

const emitMetricOnCtaClick = ({ component, slug }: CtaMetricTags): void => {
  emitMetric('service-landing-cta-click', {
    device: getSourceDescription(),
    component,
    slug,
  });
  dataLayer?.push({
    event: 'service-landing-cta-click',
    source: component,
    pageSlug: slug,
  });
};

export default emitMetricOnCtaClick;
